import { createSlice } from '@reduxjs/toolkit'

const initialState = { isMenuWhite: false, isMobileMenu: false }

const navbarSlice = createSlice({
	name: 'navbar',
	initialState,
	reducers: {
		setIsMenuWhite(state, { payload }) {
			return { ...state, isMenuWhite: payload }
		},
		setIsMobileMenu(state, { payload }) {
			return { ...state, isMobileMenu: payload }
		},
	},
})

export const { setIsMenuWhite, setIsMobileMenu } = navbarSlice.actions

export default navbarSlice.reducer
